import { render } from "./SalesData.vue?vue&type=template&id=0412cd0b"
import script from "./SalesData.vue?vue&type=script&lang=js"
export * from "./SalesData.vue?vue&type=script&lang=js"

import "./SalesData.vue?vue&type=style&index=0&id=0412cd0b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__